<div class="title" mat-dialog-title>
    <mode-dialog-header>
      <h1 class="dialog-heading" heading>Create a Dataset from this query</h1>
    </mode-dialog-header>
  </div>
  <section class="body">
    <p class="text">This generates a Reusable Dataset from your SQL query code and any calculated fields for use across multiple Reports. </p>

    <form class="section promote-dataset-form" [formGroup]="form">
      <div class="form-field">
        <div class="flex-center">
          <label class="mode-label" for="dataset-name"> Dataset name </label>
        </div>
        <input
          data-test="promote-dataset-name-input"
          id="dataset-name"
          class="mode-input"
          [class.mode-input-error]="form.nameErrors"
          formControlName="name"
          type="text"
          capraAutofocus
        />
        <div *ngIf="form.nameErrors as errors" class="error-msg">
          <span>Name must be 4-64 characters long</span>
        </div>
      </div>
    </form>
    <div class="dataset-details">
      <p class="mode-label">Dataset details</p>
      <mode-dataset-metadata
        *ngIf="enhancedDatasetResult$ | async as dataset"
        [isSheetDataset]="false"
        [isNotebookCell]="(isNotebookCell$ | async) ?? false"
        [hasCalcFields]="(hasCalcFields$ | async) ?? false"
        [rowCount]="dataset.rowCount ?? 0"
        [columnCount]="dataset?.metaColumns?.length ?? 0"
        [size]="dataset.bytes ?? 0"
        [connection]="(datasourceDisplayName$ | async) ?? ''"
        [collection]="(dataset$ | async)?.details?.collection?.name ?? 'Personal'"
        [showSchedules]="false"
      ></mode-dataset-metadata>
    </div>
  </section>
  <mode-status-banner show-icon="false" class="info-banner" status="info" layout="full-width">
    <span><b>Untitled Dataset</b> will be added to your <b>Personal content</b> and will be usable in Reports by anyone with <b>view access to your Personal content.</b></span>
  </mode-status-banner>
  <div mat-dialog-actions>
    <capra-button
      class="cancel-btn"
      text="Cancel"
      data-test="cancel-promote-dataset"
      variant="secondary"
      color="neutral"
      modeTrackClick
      [trackClickData]="{ location: 'Promote dataset modal', action: 'Promote dataset close CTA' }"
      (clicked)="close()"
    ></capra-button>
    <capra-button
      text="Promote"
      data-test="promote-dataset"
      [disabled]="!form.valid"
      modeTrackClick
      [trackClickData]="{ location: 'Promote dataset modal', action: 'Promote dataset CTA' }"
      (clicked)="promoteDataset()"
    ></capra-button>
  </div>